export const SURVEY_OF_OWNER_REQUEST = "SURVEY_OF_OWNER_REQUEST";
export const SURVEY_OF_OWNER_SUCCESS = "SURVEY_OF_OWNER_SUCCESS";
export const SURVEY_OF_OWNER_FAIL = "SURVEY_OF_OWNER_FAIL";
export const SURVEY_OF_OWNER_CLEAR_ERRORS = "SURVEY_OF_OWNER_CLEAR_ERRORS";

export const SURVEY_REQUEST = "SURVEY_REQUEST";
export const SURVEY_SUCCESS = "SURVEY_SUCCESS";
export const SURVEY_FAIL = "SURVEY_FAIL";
export const SURVEY_CLEAR_ERRORS = "SURVEY_CLEAR_ERRORS";

export const SURVEY_ANS_SUBMIT_REQUEST = "SURVEY_ANS_SUBMIT_REQUEST";
export const SURVEY_ANS_SUBMIT_SUCCESS = "SURVEY_ANS_SUBMIT_SUCCESS";
export const SURVEY_ANS_SUBMIT_FAIL = "SURVEY_ANS_SUBMIT_FAIL";
export const SURVEY_ANS_SUBMIT_CLEAR_ERRORS = "SURVEY_ANS_SUBMIT_CLEAR_ERRORS";

export const SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST =
  "SURVEY_OF_OWNER_ASSIGN_TO_USER_REQUEST";
export const SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS =
  "SURVEY_OF_OWNER_ASSIGN_TO_USER_SUCCESS";
export const SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL =
  "SURVEY_OF_OWNER_ASSIGN_TO_USER_FAIL";
export const SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS =
  "SURVEY_OF_OWNER_ASSIGN_TO_USER_CLEAR_ERRORS";

// get survey assign by survey id to update survey assign
export const SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST =
  "SURVEY_ASSIGN_BY_SURVEY_ID_REQUEST";
export const SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS =
  "SURVEY_ASSIGN_BY_SURVEY_ID_SUCCESS";
export const SURVEY_ASSIGN_BY_SURVEY_ID_FAIL =
  "SURVEY_ASSIGN_BY_SURVEY_ID_FAIL";
export const SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS =
  "SURVEY_ASSIGN_BY_SURVEY_ID_CLEAR_ERRORS";
